import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { IRating } from '../_shared/models/rating/rating.model';
import { RatingItemComponent } from './rating-item.component';

@Component({
    selector: 'sirius-rating',
    templateUrl: './rating.component.html',
    styleUrl: './rating.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RatingItemComponent],
    host: {
        class: 'sir-rating sir-text-style-paragraph-m-default',
    },
})
export class RatingComponent {
    readonly ratings = input<IRating[] | undefined>();
    readonly max = input(5);
}
